import { render } from "./AgentPerformance.vue?vue&type=template&id=0c33df6c&scoped=true"
import script from "./AgentPerformance.vue?vue&type=script&lang=js"
export * from "./AgentPerformance.vue?vue&type=script&lang=js"

import "./AgentPerformance.vue?vue&type=style&index=0&id=0c33df6c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c33df6c"]])

export default __exports__